import {
  Component, OnInit, Renderer2, ElementRef,
  Input, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchModel } from 'shared/search/search.model';

import { StatusModel } from 'shared/search/status.model';

import { DashboardSearchService } from './dashboard-search.service';
import { DashboardSearchComponent } from './base/dashboard-search.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-approved',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchApprovedComponent extends DashboardSearchComponent {

  name: string = 'approved';
  text: string = 'Approved';
  count: number = 0;
  statusId: number = 2; // APPROVED

  @Input() invalid: boolean = false;

  constructor(
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected searchService: DashboardSearchService,
    protected router: Router,
    protected _renderer: Renderer2,
    protected ref: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {
    super(
      brandService,
      permissionsService,
      searchService,
      router,
      _renderer,
      ref,
      elementRef,
    );
  }

  get link(): string {
      return '/my-products/working';
  }
  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

  protected initSearchModel() {
    this.searchModel = new SearchModel();
    this.searchModel.route = 'working';
    this.searchModel.statusModel = new StatusModel();
    this.searchModel.statusModel.id = this.statusId;
    this.searchModel.itemsPerPage = 1;
  }

  protected setData(data: any) {
    this.count = _.get(data, 'total', '--');
    this.updateStatusModel(data);
  }

}
